import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { WidgetEmptyState } from '@web/components/layout/WidgetEmptyState/WidgetEmptyState';
export var WIDGET_CHART_DEFAULT_HEIGHT = 400;
export function WidgetChartPlotArea(_a) {
    var isEmpty = _a.isEmpty, _b = _a.chartHeight, chartHeight = _b === void 0 ? WIDGET_CHART_DEFAULT_HEIGHT : _b, children = _a.children;
    if (isEmpty) {
        return _jsx(WidgetEmptyState, { minHeight: chartHeight });
    }
    return _jsx(_Fragment, { children: children });
}
